import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const POLL_MS = 15000;

export const fmtTime = (iso, tz) => {
    if (!iso) return '—';
    try {
        return new Intl.DateTimeFormat('es', { timeZone: tz || undefined, hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(iso));
    } catch { return '—'; }
};

// ISO -> "YYYY-MM-DDTHH:mm" en la zona horaria de la aerolínea (para inputs datetime-local)
export const toLocalInput = (iso, tz) => {
    const d = iso ? new Date(iso) : new Date();
    const s = new Intl.DateTimeFormat('sv-SE', { timeZone: tz || undefined, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(d);
    return s.replace(' ', 'T').slice(0, 16);
};

export const fmtMin = (m) => (m === null || m === undefined ? '—' : `${Math.round(m)} min`);

export const TIMING = {
    sin_iniciar: { label: 'Sin iniciar', bar: 'bg-slate-500/60', badge: 'bg-slate-500/15 text-slate-700 dark:text-slate-300 border-slate-500/30' },
    a_tiempo: { label: 'A tiempo', bar: 'bg-emerald-500', badge: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/30' },
    cerca: { label: 'Cerca del límite', bar: 'bg-amber-500', badge: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30' },
    excedido: { label: 'Excedido', bar: 'bg-red-500', badge: 'bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30' },
};

export const STATE_LABEL = { pendiente: 'Pendiente', en_curso: 'En curso', completada: 'Completada' };

export const HEADER_COLOR = {
    green: { text: 'text-emerald-700 dark:text-emerald-400', ring: 'border-emerald-500/40 bg-emerald-500/5', label: 'Dentro del tiempo' },
    amber: { text: 'text-amber-700 dark:text-amber-400', ring: 'border-amber-500/40 bg-amber-500/5', label: 'Cerca del límite' },
    red: { text: 'text-red-700 dark:text-red-400', ring: 'border-red-500/40 bg-red-500/5', label: 'Excedido' },
};

export const TA_STATUS = { pendiente: 'Pendiente', en_curso: 'En curso', completado: 'Completado' };

export const errMsg = (e, fallback = 'Error') => {
    const d = e?.response?.data?.detail;
    if (!d) return fallback;
    if (typeof d === 'string') return d;
    if (d.errors) return `${d.message}: ${d.errors.join(' · ')}`;
    return d.message || fallback;
};

export async function downloadFile(url, headers, filename) {
    const res = await axios.get(url, { headers, responseType: 'blob' });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
}
